"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var catalog_service_1 = require("../../../utils/catalog-service");
var widget_utils_1 = require("./widget.utils");
/**
 * @doc PrivateWidgets
 */
var PrivateWidgets = /** @class */ (function (_super) {
    tslib_1.__extends(PrivateWidgets, _super);
    function PrivateWidgets() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates or updates Widget metadata.
     *
     * @param {string} widgetId
     * @param {WidgetMetadata} data
     * @param {AxiosRequestConfig} requestConfig
     * @returns {AxiosPromise<WidgetResponse>}
     * @example
     *
     * const widget = await new PrivateWidgets()
     *  .create('widgetId', {
     *    instance_id: 'fake-instance-id',
     *    comp_id: 'fake-comp-id',
     *    page_id: 'fake-page-id',
     *    settings: {
     *      list_id: 'list-id',
     *      item_id: 'item-id'
     *    }
     *  })
     *  .then(response => response.data);
     */
    PrivateWidgets.prototype.create = function (widgetId, data, requestConfig) {
        // TODO: replace with POST
        return this.axiosInstance.put("/catalog/widgets/" + widgetId, data, requestConfig);
    };
    /**
     * Removes metadata associated with widgetId.
     * @param {string} widgetId
     * @param {AxiosRequestConfig} requestConfig
     * @returns {AxiosPromise}
     *
     * @example
     * try {
     *  await new PrivateWidgets()
     *    .remove('widgetId');
     * } catch (e) {
     *    // ...
     * }
     */
    PrivateWidgets.prototype.remove = function (widgetId, requestConfig) {
        return this.axiosInstance.delete("/catalog/widgets/" + widgetId, requestConfig);
    };
    /**
     * Updates settings for given widgetId.
     * @param {string} widgetId
     * @param {WidgetSettings} data
     * @param {AxiosRequestConfig} requestConfig
     * @returns {AxiosPromise<WidgetSettings>}
     * @example
     *
     * const updatedSettings = await new PrivateWidgets()
     *  .updateSettings('widgetId', {
     *    list_id: 'new-list-id',
     *    item_id: 'new-item-id',
     *  })
     *  .then(response => response.data);
     */
    PrivateWidgets.prototype.updateSettings = function (widgetId, data, requestConfig) {
        return this.axiosInstance.put("/catalog/widgets/" + widgetId + "/settings", data, requestConfig);
    };
    /**
     * Returns settings for given widgetId.
     * @param {string} widgetId
     * @param {AxiosRequestConfig} requestConfig
     * @returns {AxiosPromise<WidgetSettings>}
     */
    PrivateWidgets.prototype.getSettings = function (widgetId, requestConfig) {
        return this.axiosInstance.get("/public/widgets/" + widgetId + "/settings", requestConfig);
    };
    /**
     * Returns list of widgets for given instanceId.
     * @param {string} instanceId
     * @param {AxiosRequestConfig} requestConfig
     * @returns AxiosPromise<WidgetListResponse>
     */
    PrivateWidgets.prototype.getSettingsByInstanceId = function (instanceId, requestConfig) {
        return this.axiosInstance.get("/public/widgets?instance_id=" + instanceId, requestConfig);
    };
    /**
     * Returns list of deep links for given channelId.
     * One channel can be used in many widgets.
     * @param {string} channelId
     * @param {AxiosRequestConfig} requestConfig
     * @returns {AxiosPromise<DeepLinkListResponse>}
     */
    PrivateWidgets.prototype.getChannelDeepLinks = function (channelId, requestConfig) {
        return this.axiosInstance.get("/public/widgets/deeplinks?list_id=" + channelId, requestConfig);
    };
    PrivateWidgets.prototype.buildDeeplinksUrl = function (config) {
        var host = config.host, channelId = config.channelId, videoId = config.videoId, instance = config.instance, fallbackUrl = config.fallbackUrl;
        var params = {
            fallback_url: fallbackUrl,
            list_id: channelId,
            item_id: videoId,
            instance: instance,
        };
        var queryString = widget_utils_1.buildQueryString(params);
        return host + "/public/widgets/deeplinks/active/redirect?" + queryString;
    };
    PrivateWidgets.prototype.buildVideoCardsDeeplinkUrl = function (config) {
        return this.buildDeeplinksUrl(config);
    };
    PrivateWidgets.prototype.buildChannelCardsDeeplinkUrl = function (config) {
        return this.buildDeeplinksUrl(config);
    };
    return PrivateWidgets;
}(catalog_service_1.CatalogService));
exports.PrivateWidgets = PrivateWidgets;
//# sourceMappingURL=widgets.js.map